import _ from 'lodash'
import { CancelToken } from 'axios'
import { OmnitechApi } from '../../api'
import { cancelRequest } from '../../helpers'
import { isErrorExist, convertResponseToErrorObject } from '../../omnitech-error'

export function fetchProduct(options = {}) {
  const { id, ...others } = options
  const params = {
    id,
    ...others
  }
  const source = CancelToken.source()
  cancelRequest.add(
    'fetchProduct',
    () => source.cancel('fetchProduct: Operation cancelled by user')
  )

  return OmnitechApi
    .request({
      endpoint: `products/${id}`,
      method: 'get',
      params,
      arrayFormat: 'brackets',
      cancelToken: source.token
    })
    .catch(error => {
      if (cancelRequest.isCancel(error)) {
        throw cancelRequest.getErrorObject()
      }
      throw convertResponseToErrorObject(_.get(error, 'response.data'), { useResponseMessage: true })
    })
    .then(response => {
      if (isErrorExist(response.data)) throw convertResponseToErrorObject(response.data, { useResponseMessage: true })
      return response.data
    })
    .then(({ data, seoMetas }) => ({
      product: data.product,
      seoMetas,
    }))
}
